import httpManager from "@/app/shared/utils/httpManager";

export async function transferOwner(data) {
  const response = await httpManager.put("/settings/transfer-owner/", data);
  return response.data;
}
